import { Box, Card, useTheme, useMediaQuery, Chip, Typography, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react'
import Loading from '../../../components/Loader/Loading';
import MultiColumnFilter from '../../../components/Filter/MultiColumnFilter';
import { DataGrid } from '@mui/x-data-grid';
import NoRowsLayout from '../../../components/Layout/NoRowsLayout';
import CustomPagination from '../../../components/pagination/CustomPagination';
import { LeadsServices } from './LeadsServices';

const Leads = () => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const columns = [
        {
            field: 'id',
            headerName: 'S.No',
            width: 100,
            headerAlign: 'center',
            flex:0.5,
            valueGetter: (params) => 
              paginationModel.page * paginationModel.pageSize + params.api.getRowIndexRelativeToVisibleRows(params.id)+1,
        },
        { field: "customer", headerAlign: 'center', headerName: "Customer Details", flex: 2, sortable:false,
            renderCell: (params) => (
                <Box sx={{ p: 1, display: { xs: 'block', sm: 'flex' }, justifyContent: 'flex-start', width: '100%' }}>
          <Stack
            direction="column"
            spacing={1}
            justifyContent="flex-start"
            sx={{ mt: 1, width: '100%' }}
          >
            <Box sx={{ display: { xs: 'block', sm: 'flex' }, gap: '5%', justifyContent: 'flex-start', width: '100%' }}>
              <Box>
                <Typography
                  variant="body2"
                  sx={{ fontSize: '.65rem', fontWeight: 500, }}
                  color={params.row?.fullName ? '#1976d2' : '#d32f2f'}
                >
                  {`${params.row?.fullName || ''}`}
                </Typography>
                <Box>
                  <Typography variant="caption" sx={{ fontSize: '0.5rem' }}>{params.row?.email || 'N/A'}</Typography>
                  <Typography sx={{ fontSize: '0.5rem' }}> <Box component={'span'} sx={{ fontWeight: 600 }}>Mobile:</Box>{` ${params.row.mobileNumber}`}</Typography>
                </Box>
              </Box>

            </Box>
          </Stack>
        </Box>
            )
        },
        { field: "enquiry", headerAlign: 'center', headerName: "Enquiry Details", flex: 1.5, sortable:false,
            renderCell: (params) => (
                <Box sx={{p:1, gap: '5%', width: '100%' }}>
                    
                    <Box>
                        <Typography sx={{ fontSize: '0.5rem' }}> <Box component={'span'} sx={{ fontWeight: 600 }}>Event:</Box>{` ${params.row?.lynsEvents?.title}`}</Typography>
                    </Box>
                    <Box>
                        <Typography sx={{ fontSize: '0.5rem' }}> Package:</Typography>
                        <Chip
                            //   icon={statusConfigs[params.row.reviewStatus]?.icon}
                            label={params.row?.lynsPackages?.title}
                            size="small"
                            variant="outlined"
                            sx={{ fontSize: '0.5rem', height: 'fit-content', '& .MuiChip-icon': { fontSize: '0.65rem' } }}
                        />
                    </Box>                     
                </Box>                
            )
        },
        // { field: "phone", headerAlign: 'center', headerName: "Phone", flex: 2, sortable:false, },
        // { field: "email", headerAlign: 'center', headerName: "Email", flex: 2, sortable:false, },
        // { field: "status", headerAlign: 'center', headerName: "Status", flex: 1, sortable:false, },
    ];
    const [leadsList, setLeadsList] = useState([]);
    const [loading, setLoading] = useState(false);

    const [allRowCount, setAllRowCount] = useState(0);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 50,
        filters: {
            searchKey: "",
            sortKey: 'createdAt',
            sortDirection : 'desc',
            filterOptions: []
        }
    });
    const handlePaginationChange = (newPagination) => {
    setPaginationModel({
        ...paginationModel,
        page: newPagination.page,
        pageSize: newPagination.pageSize
        });
    }
    const [sortModel, setSortModel] = useState([
        {
            field: paginationModel.filters.sortKey,
            sort: paginationModel.filters.sortDirection,
        },
    ]);

    const handleSortingChange = (newSortModel) => {
        console.log("new sort model", newSortModel);
        if (newSortModel && newSortModel.length > 0) {
            setSortModel(newSortModel);
            setPaginationModel(prev => ({
            ...prev,
            filters: {
                ...prev.filters,
                sortKey: newSortModel[0].field,
                sortDirection: newSortModel[0].sort
            }
            }));
        }
    }

    const fetchLeadsList = async () => {
        setLoading(true);
        let data ={
            page: paginationModel.page,
            limit: paginationModel.pageSize,
            filters: {
                searchKey: paginationModel.filters.searchKey,
                sortKey:paginationModel.filters.sortKey,
                sortDirection:paginationModel.filters.sortDirection,
                filterOptions: paginationModel.filters.filterOptions || []
            }
        }
        const response = await LeadsServices.fetchLeadsList(data);
        // console.log("leads list Response:",response);
        if (response.success == '1') {
            setLeadsList(response.data.leads);
            setAllRowCount(response.data.totalItems);
        }
        setLoading(false);
    }
    useEffect(() => {
        fetchLeadsList();
    }, [paginationModel]);
  return (
    <>
        <Card>
            <Box sx={{ overflow: "auto" }}>
                <Box 
                    sx={{ 
                        width: "100%", display: "table",  tableLayout: "fixed", 
                        backgroundColor: "#fff", borderRadius: '.5rem',
                        '& .odd': {
                        bgcolor: 'white',
                        },
                        '& .even': {
                        bgcolor: '#ECECEC',
                        },
                    }}
                >
            
                    {loading && <Loading/>}
                    {/* custom toolbar */}
                    <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between',alignItems:'center',px:'1%' }}>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            {/* <MultiColumnFilter
                                filterableColumns={filterableColumns}
                                onApplyFilter={handleApplyFilter}
                                externalClear={clearMultiFilter}
                                defaultFilterOptions={paginationModel.filters.filterOptions}
                            /> */}
                            {/* <ExportAll 
                                paginationModel={paginationModel} 
                                columns={columns} 
                                // statusOptions={statusOptions} 
                            /> */}
                        </Box>
                        {/* <Box>
                            <TextField
                                value={quickFilterText}
                                onChange={(event) => setQuickFilterText(event.target.value)}
                                placeholder="Quick Search ..."
                                size="small"
                                fullWidth
                                sx={{
                                '& .MuiOutlinedInput-root': {
                                    paddingLeft: '0px',
                                }
                                }}
                                InputProps={{
                                inputProps: {
                                    style: {
                                    height: '0.6rem',
                                    // textTransform: 'uppercase',
                                    fontSize: 'x-small'
                                    },
                                },
                                startAdornment: (
                                    <InputAdornment position="start">
                                    <IconButton>
                                        <Search sx={{fontSize:'x-small'}}/>
                                    </IconButton>
                                    </InputAdornment>
                                ),
                                }}
                            />
                        </Box> */}
                    </Box>
                    <DataGrid
                        rows={leadsList}
                        columns={columns.map((col) => ({
                        ...col,
                        // flex: col.flex || 1, // Ensure columns resize dynamically
                        minWidth: isSmallScreen && (col.minWidth || 180), // Set a minimum width to avoid overlap
                        }))}
                        // getRowId={(row) => row.id}
                        //checkboxSelection={true}
                        rowCount={allRowCount}  // Use the length of the filtered list
                        pageSizeOptions={[5, 10, 20, 50, 100]}
                        paginationModel={paginationModel}
                        paginationMode="server"
                        onPaginationModelChange={handlePaginationChange}
                        // filterModel={filterModel}
        
                        sortingMode="server"
                        sortModel={sortModel}
                        onSortModelChange={handleSortingChange}
                        disableMultiSort={true}
                        sortingOrder={['asc', 'desc']}
        
                        loading={loading}
        
                        disableColumnMenu
                        disableRowSelectionOnClick
                        // disableColumnFilter
                        // disableColumnSelector
                        disableDensitySelector
                        slots={{
                        // toolbar: GridToolbar,
                        noRowsOverlay: NoRowsLayout,
                        loadingOverlay: Loading,
                        pagination:CustomPagination,
                        }}
                        // slotProps={{
                        //   toolbar: {
                        //     showQuickFilter: true,  
                        //   },
                        // }}
                        // rowHeight={50}
                        autoHeight
                        getRowHeight={() => 'auto'}
                        sx={{
                            minWidth: "100%", // Ensures DataGrid expands inside scrollable container
                            "& .MuiDataGrid-root": {
                            overflowX: "auto",
                            },
                            '& .MuiDataGrid-cell': {
                            border: 1,
                            borderRight: 0,
                            borderTop: 0,
                            borderColor: 'lightgrey',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            },
                            '& .MuiDataGrid-columnHeaders': {
                            borderBottom: '2px solid rgba(224, 224, 224, 1)',
                            borderTop: '2px solid rgba(224, 224, 224, 1)',
                            fontWeight: 600,
                            fontSize: '0.75rem',
                            p:0,
                            height: 'fit-content',
                            minHeight:'0 !important',
                            height:'2rem'
                            },
                            '& .MuiDataGrid-columnHeader': {
                            borderLeft: '1px solid rgba(224, 224, 224, 1)',
                            '&:last-child': {
                                borderRight: 'none',
                            },
                            },
                            '& .MuiDataGrid-columnHeaderTitle': {
                            fontWeight: 600,
                            color: '#3e3e3e'
                            },
                            '& .MuiDataGrid-row': {
                            '&:last-child .MuiDataGrid-cell': {
                                borderBottom: '1px solid rgba(224, 224, 224, 1)',
                            },
                            '& .MuiDataGrid-cell:last-child': {
                                borderRight: 'none',
                            },
                            },
                            '& .MuiDataGrid-columnSeparator': {
                            display: 'none',
                            },
                        }}
                    />
                </Box>
            </Box>
        </Card>
      
    </>
  )
}

export default Leads
